<tt-page>
    <tt-list class="col-xs-12 col-md-6 sp-0" [ttData]="itemsListStockIncomings"></tt-list>
</tt-page>
